var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_38779",
    "data-name": "Group 38779",
    transform: "translate(17136)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14932",
    "data-name": "Rectangle 14932",
    width: 24,
    height: 24,
    transform: "translate(-17136)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "phone_1_",
    "data-name": "phone (1)",
    d: "M23.933,18.611a1.716,1.716,0,0,0-.872-1.086L18.583,15.2a1.705,1.705,0,0,0-2.172.5l-.724.992a.261.261,0,0,1-.337.076,13.141,13.141,0,0,1-2.9-2.234,13.145,13.145,0,0,1-2.234-2.9A.261.261,0,0,1,10.3,11.3l.988-.724a1.705,1.705,0,0,0,.5-2.172L9.475,3.931a1.712,1.712,0,0,0-2.469-.637L4.193,5.177A2.708,2.708,0,0,0,2.991,7.6a13.626,13.626,0,0,0,.322,2.378,19.427,19.427,0,0,0,5.166,8.54,19.279,19.279,0,0,0,8.54,5.155,13.637,13.637,0,0,0,2.378.322h.181A2.708,2.708,0,0,0,21.816,22.8l1.875-2.813A1.712,1.712,0,0,0,23.933,18.611Zm-1.448.572L20.621,22a1.267,1.267,0,0,1-1.129.554,12.514,12.514,0,0,1-2.111-.279,17.86,17.86,0,0,1-7.874-4.789A18.012,18.012,0,0,1,4.721,9.612,12.5,12.5,0,0,1,4.439,7.5a1.256,1.256,0,0,1,.554-1.126L7.806,4.5a.257.257,0,0,1,.145-.043h.069a.261.261,0,0,1,.167.134L10.5,9.069a.264.264,0,0,1-.076.333l-.988.724a1.709,1.709,0,0,0-.463,2.219,14.676,14.676,0,0,0,2.462,3.189A14.669,14.669,0,0,0,14.626,18a1.709,1.709,0,0,0,2.219-.463l.724-.992a.264.264,0,0,1,.333-.076l4.478,2.317a.264.264,0,0,1,.1.38Z",
    transform: "translate(-17137.486 -1.507)",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.401e2cbe986365f3be3984ecd4416dfb.svg";
export { ForwardRef as ReactComponent };